import { colors } from "healthex-common/colors";
import { ReportRunStatus } from "healthex-common/reports.dtos";
import styled from "styled-components";
import { FlexColumnDiv, FlexRowDiv } from "../common.styles";
export const GenerateSection = styled.div `
    margin-bottom: 24px;
    padding: 20px;
    background-color: ${colors.black_4};
    border-radius: 8px;
`;
export const SectionHint = styled.p `
    margin: 0 0 16px;
    font-size: 12px;
    color: ${colors.black_lighter};
`;
export const GenerateRow = styled(FlexRowDiv) `
    gap: 16px;
    align-items: flex-end;
    flex-wrap: wrap;
`;
export const FieldGroup = styled(FlexColumnDiv) `
    gap: 6px;
`;
export const FieldLabel = styled.label `
    font-size: 12px;
    font-weight: 600;
    color: ${colors.black_lighter};
`;
export const ReportSelect = styled.select `
    padding: 8px 12px;
    border: 1px solid ${colors.black_30};
    border-radius: 4px;
    background-color: white;
    font-size: 14px;
    min-width: 260px;
`;
export const ParamInput = styled.input `
    padding: 8px 12px;
    border: 1px solid ${colors.black_30};
    border-radius: 4px;
    font-size: 14px;
    min-width: 180px;
`;
export const ReportDescription = styled.p `
    margin: 12px 0 0;
    font-size: 13px;
    color: ${colors.black_lighter};
    max-width: 70ch;
`;
export const ScheduleNote = styled.span `
    font-size: 12px;
    color: ${colors.black_lighter};
    margin-left: 8px;
`;
export const TableWrapper = styled.div `
    overflow-x: auto;
    border: 1px solid ${colors.black_8};
    border-radius: 8px;
`;
export const RunsTable = styled.table `
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    thead th {
        text-align: left;
        padding: 12px 16px;
        background-color: ${colors.black_4};
        border-bottom: 1px solid ${colors.black_8};
        font-weight: 600;
        white-space: nowrap;
    }

    tbody td {
        padding: 12px 16px;
        border-bottom: 1px solid ${colors.black_4};
        vertical-align: top;
    }

    tbody tr:last-child td {
        border-bottom: none;
    }
`;
export const NumericCell = styled.td `
    font-variant-numeric: tabular-nums;
    text-align: right;
    white-space: nowrap;
`;
export const StatusBadge = styled.span `
    display: inline-block;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    white-space: nowrap;
    background-color: ${(props) => {
    switch (props.status) {
        case ReportRunStatus.SUCCEEDED:
            return "#E8F5E9";
        case ReportRunStatus.FAILED:
            return "#FDECEA";
        case ReportRunStatus.RUNNING:
            return "#E3F2FD";
        case ReportRunStatus.QUEUED:
            return "#FFF8E1";
        default:
            return colors.black_8;
    }
}};
    color: ${(props) => {
    switch (props.status) {
        case ReportRunStatus.SUCCEEDED:
            return "#2E7D32";
        case ReportRunStatus.FAILED:
            return "#C62828";
        case ReportRunStatus.RUNNING:
            return "#1565C0";
        case ReportRunStatus.QUEUED:
            return "#F57F17";
        default:
            return colors.black_main;
    }
}};
`;
export const ClassificationBadge = styled.span `
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    background-color: ${(props) => (props.sensitive ? "#FDECEA" : colors.black_8)};
    color: ${(props) => (props.sensitive ? "#C62828" : colors.black_main)};
`;
export const ErrorCell = styled.span `
    color: #c62828;
    display: inline-block;
    max-width: 40ch;
    word-break: break-word;
`;
export const ErrorBanner = styled.div `
    margin-bottom: 16px;
    padding: 12px 16px;
    background-color: #fdecea;
    border: 1px solid #f5c2c0;
    border-radius: 4px;
    color: #c62828;
    font-size: 13px;
`;
export const EmptyState = styled.div `
    padding: 32px;
    text-align: center;
    color: ${colors.black_lighter};
`;
export const LoadMoreRow = styled(FlexRowDiv) `
    justify-content: center;
    padding: 16px;
`;
export const MutedText = styled.span `
    color: ${colors.black_lighter};
`;
export const ScheduleSection = styled.div `
    margin-bottom: 24px;
    padding: 20px;
    background-color: white;
    border: 1px solid ${colors.black_8};
    border-radius: 8px;
`;
export const ScheduleHeader = styled(FlexRowDiv) `
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
`;
export const ScheduleTitle = styled.h3 `
    margin: 0 0 6px;
    font-size: 14px;
    font-weight: 600;
`;
export const ScheduleSummaryText = styled.div `
    font-size: 14px;
`;
export const ScheduleMeta = styled.div `
    font-size: 12px;
    color: ${colors.black_lighter};
    margin-top: 4px;
`;
export const ScheduleEditorRow = styled(FlexRowDiv) `
    gap: 16px;
    align-items: flex-end;
    flex-wrap: wrap;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid ${colors.black_8};
`;
export const ScheduleActions = styled(FlexRowDiv) `
    gap: 8px;
    margin-top: 16px;
`;
export const CronPreview = styled.code `
    display: inline-block;
    padding: 4px 8px;
    background-color: ${colors.black_4};
    border-radius: 4px;
    font-size: 12px;
`;
export const ScheduleWarning = styled.div `
    margin-top: 12px;
    padding: 10px 12px;
    background-color: #fff8e1;
    border: 1px solid #ffe082;
    border-radius: 4px;
    font-size: 12px;
    color: #8d6e00;
`;
export const ToggleLabel = styled.label `
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    cursor: pointer;
`;
